/* eslint-disable react-hooks/exhaustive-deps */
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoadingButton } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../components/table/Table";
import {
  fetchBankAccounts,
  fetchHmoBankAccounts,
  getHmoData,
  setPagination,
} from "../../../../features/hmo/hmoSlice";
import HomeLayout from "../../../../layouts/Home";
import config from "../../../../utils/config";
import Menu from "../../../../utils/data.dropdown";
import { getIds } from "../../../../utils/helper";

const { routes } = config;
const HmoAccounts = () => {
  const navigate = useNavigate();
  const { pagination, loading, myBankAccounts, bankAccounts } =
    useSelector(getHmoData);

  const dispatch = useDispatch();

  useEffect(() => {
    let cb = () => {};
    if (pagination.search) {
      dispatch(setPagination({ page: 1 }));
      cb = setTimeout(
        (_) =>
          (async () => await dispatch(fetchHmoBankAccounts(getIds()?.hmo)))(),
        700
      );
    } else
      cb = (async () => await dispatch(fetchHmoBankAccounts(getIds()?.hmo)))();

    return () => {
      clearTimeout(cb);
    };
  }, [pagination.search, pagination.page]);

  useEffect(() => {
    dispatch(fetchBankAccounts());
  }, []);

  const data = useMemo(() => {
    return myBankAccounts?.map((account) => {
      const bankName =
        account?.bank?.name ||
        bankAccounts?.find((b) => Number(b?.id) === Number(account?.bankId))
          ?.name;

      return {
        "Account Name": account?.accountName,
        "Account Number": account?.accountNumber,
        "Bank Name": bankName || "N/A",
        _data: {
          ...account,
          bank: bankName,
        },
      };
    });
  }, [myBankAccounts, bankAccounts]);

  const menu = new Menu({});
  const dropdownMenu = [
    menu.edit({
      navigate,
      route: routes.hmos.configurations.accounts.account,
    }),
  ];

  return (
    <HomeLayout {...{ title: "Configuration" }}>
      <Box className="flex text-[var(--c-dark-1)]">
        <ArrowBackIcon
          onClick={(_) => navigate(-1)}
          className=" mr-2 cursor-pointer"
          fontSize="small"
        />
        <Typography className="text-[400] text-[16px] ">Go back</Typography>
      </Box>
      <Box className="flex justify-end">
        <LoadingButton
          LinkComponent={Link}
          className="w-[213px] h-[56px] bg-[var(--c-primary-0)] text-[var(--c-bg-color)] font-semibold text-[18px] rounded-xl shadow-none normal-case"
          size="small"
          type="submit"
          variant="contained"
          to={routes.hmos.configurations.accounts.new}
          fullWidth
        >
          Add Account
        </LoadingButton>
      </Box>
      <Box
        className="pt-8 px-8 mt-14 pb-2 bg-[var(--c-bg-color)] rounded-lg w-100%"
        sx={{ p: 0 }}
      >
        <Table
          {...{
            data,
            dropdownMenu,
            isLoading: loading,
            pagination,
            setPagination: (data) => dispatch(setPagination(data())),
          }}
        />
      </Box>
    </HomeLayout>
  );
};

export default HmoAccounts;
